export default __webpack_public_path__ + "static/media/wifi.13020956.svg";